{
  "ru": {
    "Bosh sahifa": "Главная",
    "Toʻplamlar": "Наборы",
    "Oʻyinlar": "Игры",
    "Kutubxona": "Библиотека",
    "Profil": "Профиль",
    "Orqaga": "Назад",
    "Yopish": "Закрыть",
    "Chiqish": "Выйти",
    "Qidirish": "Поиск",
    "Bildirishnomalar": "Уведомления",
    "Tilni almashtirish": "Сменить язык",
    "Tilni tanlang": "Выберите язык",
    "Davom etish": "Продолжить",
    "Lexo Telegram ichida ishlaydi": "Lexo работает внутри Telegram",
    "Ilovani Telegram botidan oching — progressingiz Telegram hisobingizga bogʻlanadi va hech qachon yoʻqolmaydi.": "Откройте приложение через Telegram-бота — прогресс привяжется к вашему аккаунту Telegram и никогда не потеряется.",
    "Telegramʼda ochish": "Открыть в Telegram",
    "Server bilan aloqa yoʻq": "Нет связи с сервером",
    "Internetni tekshiring va qayta urinib koʻring.": "Проверьте интернет и попробуйте снова.",
    "Qayta urinish": "Повторить",
    "Tushunarli": "Понятно",
    "Bekor qilish": "Отмена",
    "Oʻchirish": "Удалить",
    "Tekshirish": "Проверить",
    "Keyingi": "Далее",
    "Yana": "Ещё",
    "Boshlash": "Начать",
    "Tez orada": "Скоро",
    "Hammasi": "Все",
    "Barchasi": "Все",
    "Boshqa": "Другое",
    "test": "тест",
    "Test": "Тест",
    "Xayrli tong": "Доброе утро",
    "Xayrli kun": "Добрый день",
    "Xayrli kech": "Добрый вечер",
    "Xayrli tun": "Доброй ночи",
    "Lexo oʻquvchisi": "Ученик Lexo",
    "Lexo foydalanuvchisi": "Пользователь Lexo",
    "Lexo v# test": "Lexo v$1 тест",
    "Du": "Пн",
    "Se": "Вт",
    "Ch": "Ср",
    "Pa": "Чт",
    "Ju": "Пт",
    "Sh": "Сб",
    "Ya": "Вс",
    "Ingliz tili": "Английский язык",
    "Rus tili": "Русский язык",
    "Ingliz": "Английский",
    "Rus": "Русский",
    "Ingliz → oʻzbek · # soʻz (test)": "Английский → узбекский · $1 {слово|слова|слов} (тест)",
    "Rus → oʻzbek · # soʻz (test)": "Русский → узбекский · $1 {слово|слова|слов} (тест)",
    "Qaysi tilni oʻrganasiz?": "Какой язык изучаете?",
    "Har bir tilning progressi alohida saqlanadi.": "Прогресс по каждому языку хранится отдельно.",
    "Ilova tili": "Язык приложения",
    "Oʻrganilayotgan til": "Изучаемый язык",
    "Lexoʼga xush kelibsiz": "Добро пожаловать в Lexo",
    "Har kuni # daqiqa — soʻz boyligingiz oʻsib boradi. Bu # soʻzlik test versiya.": "$1 минут в день — и ваш словарный запас растёт. Это тестовая версия на $2 слов.",
    "Ismingiz": "Ваше имя",
    "Bittasini tanlang.": "Выберите один вариант.",
    "#-savol": "Вопрос $1",
    "Javobni tanlang": "Выберите ответ",
    "Lexo haqida qayerdan eshitdingiz?": "Откуда вы узнали о Lexo?",
    "Tanishim / Yaqinim": "Знакомый / близкий",
    "Oʻquv markazi": "Учебный центр",
    "Google qidiruv": "Поиск Google",
    "Yoshingiz nechada?": "Сколько вам лет?",
    "# dan kichik": "Младше $1",
    "# va undan katta": "$1 и старше",
    "Hozir nima bilan bandsiz?": "Чем вы сейчас занимаетесь?",
    "Maktab oʻquvchisi": "Школьник",
    "Talaba": "Студент",
    "Ishlayman": "Работаю",
    "Ishlamayman / uydaman": "Не работаю / дома",
    "Bu til sizga nima uchun kerak?": "Зачем вам этот язык?",
    "IELTS / CEFR imtihoni": "Экзамен IELTS / CEFR",
    "Chet elda oʻqish": "Учёба за рубежом",
    "Ish / karyera": "Работа / карьера",
    "Sayohat": "Путешествия",
    "Oʻzim uchun": "Для себя",
    "Qanday oʻrganasiz?": "Как вы учитесь?",
    "Mustaqil oʻrganaman": "Учусь самостоятельно",
    "Lexo soʻzlarni oʻzi tanlab, tasodifiy tartibda beradi": "Lexo сам подбирает слова в случайном порядке",
    "Oʻquv markazida oʻqiyman": "Учусь в учебном центре",
    "Har darsdagi soʻzlarni oʻz kartochkangizga qoʻshib oʻrganasiz": "Добавляете слова с каждого урока в свои карточки",
    "Oʻquv markazi nomi (ixtiyoriy)": "Название учебного центра (необязательно)",
    "Ingliz tilini qanchalik bilasiz?": "Как хорошо вы знаете английский?",
    "Rus tilini qanchalik bilasiz?": "Как хорошо вы знаете русский?",
    "Shunga mos soʻzlardan boshlaymiz.": "Начнём с подходящих слов.",
    "Shunga qarab darslar tartibini moslaymiz.": "Под это мы настроим порядок уроков.",
    "Noldan boshlayman": "Начинаю с нуля",
    "Oddiy gaplarni tushunaman": "Понимаю простые фразы",
    "Bemalol gaplasha olaman": "Свободно говорю",
    "Kuniga nechta yangi soʻz?": "Сколько новых слов в день?",
    "≈ # daqiqa · Yengil": "≈ $1 мин · Легко",
    "≈ # daqiqa · Meʼyorida": "≈ $1 мин · Нормально",
    "≈ # daqiqa · Jiddiy": "≈ $1 мин · Серьёзно",
    "≈ # daqiqa · Intensiv": "≈ $1 мин · Интенсив",
    "BUGUNGI DARS": "УРОК НА СЕГОДНЯ",
    "# ta soʻz qoldi": "Осталось: $1 {слово|слова|слов}",
    "Maqsad bajarildi!": "Цель выполнена!",
    "Bugungi reja bajarildi": "План на сегодня выполнен",
    "Takrorlash kunlarini kuting": "Дождитесь дней повторения",
    "+ # ta takrorlash": "+ $1 {повторение|повторения|повторений}",
    "Kartochkadan ·": "Из карточки ·",
    "Kartochkadan · + # ta takrorlash": "Из карточки · + $1 {повторение|повторения|повторений}",
    "Darsni boshlash": "Начать урок",
    "Darsni davom ettirish": "Продолжить урок",
    "Bugun tugadi": "На сегодня всё",
    "Dars kartochkasi": "Карточка урока",
    "Ixtiyoriy: darsdagi soʻzlarni qoʻshing": "Необязательно: добавьте слова с урока",
    "Joriy kartochka · #/# oʻrganildi": "Текущая карточка · изучено $1/$2",
    "Takrorlash vaqti": "Время повторения",
    "# ta soʻz kutyapti": "Ждут повторения: $1",
    "Hozircha takrorlash yoʻq": "Пока нечего повторять",
    "Qiyin soʻzlar": "Трудные слова",
    "# ta belgilangan": "Отмечено: $1",
    "Yulduzcha bilan belgilang": "Отмечайте звёздочкой",
    "Jonli ingliz tili": "Живой английский",
    "Jonli rus tili": "Живой русский",
    "# kun": "$1 {день|дня|дней}",
    "# XP": "$1 XP",
    "#-oʻrin": "$1-е место",
    "Takrorlash kuni kelgan soʻz yoʻq": "Нет слов для повторения",
    "Soʻz kartochkasidagi yulduzchani bosib belgilang": "Нажмите звёздочку на карточке слова",
    "# ta soʻz takrorlashni kutyapti": "Ждут повторения: $1",
    "Yangi bildirishnoma yoʻq": "Новых уведомлений нет",
    "Eslatmalar mobil ilovada boʻladi.": "Напоминания будут в мобильном приложении.",
    "Yangi soʻz qolmadi — takrorlash kunlarini kuting": "Новых слов нет — дождитесь дней повторения",
    "Reyting": "Рейтинг",
    "Guruh": "Группа",
    "SIZNING OʻRNINGIZ": "ВАШЕ МЕСТО",
    "#-oʻringa chiqish uchun yana": "До $1-го места осталось",
    "Siz birinchi oʻrindasiz — oʻrningizni saqlang!": "Вы на первом месте — удержите его!",
    "keyingi: #": "следующее: $1",
    "Yetakchi!": "Лидер!",
    "* (siz)": "$1 (вы)",
    "Siz": "Вы",
    "Test versiyada boshqa oʻquvchilar namunaviy. Toʻliq ilovada guruhingiz va oʻquv markazingiz oʻquvchilari chiqadi.": "В тестовой версии другие ученики — пример. В полном приложении будут ученики вашей группы и учебного центра.",
    "Darajalar": "Уровни",
    "Mavzular": "Темы",
    "Kartochkalarim": "Мои карточки",
    "Soʻz qidirish": "Поиск слов",
    "Lugʻatdan soʻz qidirish": "Поиск в словаре",
    "Bazadan soʻz qidirish": "Поиск по базе",
    "Boshlangʻich": "Начальный",
    "Elementar": "Элементарный",
    "Oʻrta": "Средний",
    "# soʻz · test toʻplami": "$1 слов · тестовый набор",
    "Eng kerakli # soʻz": "$1 самых нужных слов",
    "Kundalik mavzular": "Повседневные темы",
    "Ish, sayohat, oʻqish": "Работа, путешествия, учёба",
    "# / # soʻz boshlangan": "Начато $1 из $2",
    "Mashhur mavzular": "Популярные темы",
    "Hali kartochka yoʻq": "Карточек пока нет",
    "“Yangi kartochka” tugmasini bosing va darsdagi soʻzlarni bazadan tanlab qoʻshing.": "Нажмите «Новая карточка» и добавьте слова с урока из базы.",
    "Bitta kartochkaga # tagacha soʻz. Oʻquv markazidagi har dars uchun alohida kartochka oching. (Kartochka faollashtirilsa, darslar shu kartochkadan boradi.)": "До $1 слов в одной карточке. Создавайте отдельную карточку для каждого урока в центре. (Если карточка активна, уроки идут по ней.)",
    "Yangi kartochka": "Новая карточка",
    "Kartochka nomi": "Название карточки",
    "Masalan: #-dars": "Например: урок $1",
    "Kartochkani tahrirlash": "Редактировать карточку",
    "Bazadan soʻz tanlang": "Выберите слова из базы",
    "Kartochka toʻldi": "Карточка заполнена",
    "/ # soʻz": "/ $1 слов",
    "Saqlash va oʻrganish": "Сохранить и учить",
    "Kamida # ta soʻz tanlang": "Выберите хотя бы $1 {слово|слова|слов}",
    "Kartochka oʻchirildi": "Карточка удалена",
    "Joriy": "Текущая",
    "oʻrganilgan": "изучено",
    "Hech narsa topilmadi.": "Ничего не найдено.",
    "Bu soʻzlar allaqachon oʻrganilgan — takrorlashda chiqadi": "Эти слова уже изучены — появятся в повторении",
    "Darslar kartochkalaringizdan boradi": "Уроки идут по вашим карточкам",
    "Soʻzlar tasodifiy tartibda beriladi": "Слова даются в случайном порядке",
    "Tinglash": "Слушать",
    "Tinglash: *": "Слушать: $1",
    "Oila": "Семья",
    "Ovqat": "Еда",
    "Uy": "Дом",
    "Vaqt": "Время",
    "Shahar": "Город",
    "Feʼllar": "Глаголы",
    "Sifatlar": "Прилагательные",
    "Ranglar": "Цвета",
    "Tana": "Тело",
    "Taʼlim": "Образование",
    "ot": "сущ.",
    "feʼl": "глаг.",
    "sifat": "прил.",
    "ravish": "нареч.",
    "Kartochkalar": "Карточки",
    "Aylantiring va eslang": "Переворачивайте и вспоминайте",
    "Oʻrganish": "Изучение",
    "Tanlash, keyin yozish": "Выбор, затем письмо",
    "Juftlik": "Пары",
    "# juftni tez toping": "Быстро найдите $1 пар",
    "# savol, baho": "$1 вопросов, оценка",
    "Eshit va yoz": "Слушай и пиши",
    "Audio, sekin ijro": "Аудио, медленно",
    "Boʻsh joy": "Пропуск",
    "Gapni toʻldiring": "Заполните пропуск",
    "Tezkor #": "Блиц $1",
    "Toʻgʻri yoki notoʻgʻri": "Верно или неверно",
    "Meteor": "Метеор",
    "Toʻgʻri soʻzni otib tushiring": "Сбейте правильное слово",
    "Oʻrganilgan soʻzlar · #": "Изученные слова · $1",
    "Barcha soʻzlar · #": "Все слова · $1",
    "Oʻyinlar oʻrganilgan soʻzlaringizdan tuziladi (kamida # ta boʻlmasa — barcha # soʻzdan).": "Игры составляются из изученных слов (если их меньше $1 — из всех $2 слов).",
    "Bu oʻyin Pro versiyada boʻladi": "Эта игра будет в Pro",
    "Bu qurilmada ovoz chiqmaydi": "На этом устройстве нет звука",
    "Qaysi soʻzlar bilan oʻynaysiz?": "С какими словами играем?",
    "Tasodifiy": "Случайные",
    "Oʻzim tanlayman": "Выберу сам",
    "Qayerdan": "Откуда",
    "Oʻrganilganlar · #": "Изученные · $1",
    "Qiyin soʻzlar · #": "Трудные слова · $1",
    "Nechta soʻz": "Сколько слов",
    "Hali oʻrganilgan soʻz yoʻq": "Изученных слов пока нет",
    "Avval Bosh sahifada mashgʻulot oʻting — oʻrgangan soʻzlaringiz shu yerda chiqadi. Hozircha “Tasodifiy” rejimidan foydalaning.": "Сначала пройдите урок на главной — изученные слова появятся здесь. Пока используйте режим «Случайные».",
    "Faqat oʻrganilgan soʻzlar (# ta) koʻrsatiladi.": "Показаны только изученные слова ($1).",
    "# ta tanlandi": "Выбрано: $1",
    "ta tanlandi": "выбрано",
    "Hammasini belgilash": "Выбрать все",
    "Belgini olish": "Снять выбор",
    "Tozalash": "Очистить",
    "Oʻyinni boshlash": "Начать игру",
    "Avval soʻz oʻrganing": "Сначала выучите слова",
    "Oʻynash uchun kamida # ta oʻrganilgan soʻz kerak. Avval Bosh sahifada mashgʻulot oʻting.": "Для игры нужно минимум $1 изученных слова. Сначала пройдите урок на главной.",
    "Bu soʻzlar uchun misol gap yoʻq": "Для этих слов нет примеров",
    "KARTOCHKA": "КАРТОЧКА",
    "Tarjimani koʻrsatish": "Показать перевод",
    "Juftini toping": "Найдите пару",
    "Hammasi topildi!": "Всё найдено!",
    "· yangi rekord!": "· новый рекорд!",
    "Juftlik toʻgʻrimi? Tez javob bering.": "Пара верна? Отвечайте быстро.",
    "Toʻgʻri": "Верно",
    "Notoʻgʻri": "Неверно",
    "Tarjimasini otib tushiring": "Сбейте перевод",
    "TARJIMASINI OTIB TUSHIRING": "СБЕЙТЕ ПЕРЕВОД",
    "Toʻgʻri tarjimani bosing — toʻp uni otib tushiradi": "Нажмите на правильный перевод — пушка его собьёт",
    "#-daraja": "Уровень $1",
    "Rekord #": "Рекорд $1",
    "Rekord: #": "Рекорд: $1",
    "Yangi rekord!": "Новый рекорд!",
    "ball": "очки",
    "Meteor: # ball": "Метеор: $1 очк.",
    "Tezkor #: # ball": "Блиц $1: $2 очк.",
    "Yana oʻynash": "Играть ещё",
    "Oʻyinlarga": "К играм",
    "PRO": "PRO",
    "Tarjimani toping": "Найдите перевод",
    "Yozing": "Напишите",
    "Variantlar bilan tekshirish": "Проверка с вариантами",
    "Talaffuz": "Произношение",
    "#/# · Oʻrganish": "$1/$2 · Изучение",
    "#/# · Tarjimani toping": "$1/$2 · Найдите перевод",
    "#/# · Yozing": "$1/$2 · Напишите",
    "#/# · Variantlar bilan tekshirish": "$1/$2 · Проверка с вариантами",
    "#/# · Talaffuz": "$1/$2 · Произношение",
    "#-bosqich: *": "Этап $1: @2",
    "Har bir soʻzni koʻring, tinglang va misolni oʻqing. Strelkalar bilan oldinga-orqaga yuring.": "Смотрите каждое слово, слушайте и читайте пример. Листайте стрелками.",
    "Inglizcha soʻzning toʻgʻri oʻzbekcha tarjimasini tanlang.": "Выберите правильный узбекский перевод английского слова.",
    "Ruscha soʻzning toʻgʻri oʻzbekcha tarjimasini tanlang.": "Выберите правильный узбекский перевод русского слова.",
    "Oʻzbekcha soʻzni inglizcha yozing. Kataklar soni — harflar soni.": "Напишите узбекское слово по-английски. Клеток столько же, сколько букв.",
    "Oʻzbekcha soʻzni ruscha yozing. Kataklar soni — harflar soni.": "Напишите узбекское слово по-русски. Клеток столько же, сколько букв.",
    "Oʻzbekcha soʻzning inglizchasini variantlardan toping.": "Найдите английский вариант узбекского слова.",
    "Oʻzbekcha soʻzning ruschasini variantlardan toping.": "Найдите русский вариант узбекского слова.",
    "Namunani tinglang va soʻzni ovoz chiqarib ayting.": "Послушайте образец и произнесите слово вслух.",
    "YANGI SOʻZ · #/#": "НОВОЕ СЛОВО · $1/$2",
    "[soʻz rasmi]": "[картинка слова]",
    "Qiyin?": "Трудное?",
    "Qiyin": "Трудное",
    "Qiyin soʻz deb belgilash": "Отметить как трудное",
    "Qiyin soʻzlarga qoʻshildi": "Добавлено в трудные слова",
    "Qiyin soʻzlardan olindi": "Убрано из трудных слов",
    "Bilaman": "Знаю",
    "Bilaman ✓": "Знаю ✓",
    "Bilaman deb belgilandi": "Отмечено как известное",
    "Oldingi soʻz": "Предыдущее слово",
    "Keyingi soʻz": "Следующее слово",
    "Tekshirishni boshlash": "Начать проверку",
    "Misolni tinglash": "Послушать пример",
    "Toʻgʻri tarjimani tanlang": "Выберите правильный перевод",
    "Inglizchasini tanlang": "Выберите английский вариант",
    "Ruschasini tanlang": "Выберите русский вариант",
    "Eshiting va qaysi soʻz ekanini tanlang": "Послушайте и выберите слово",
    "Tugmani bosib eshiting va qaysi soʻz ekanini tanlang": "Нажмите, послушайте и выберите слово",
    "Inglizcha yozing": "Напишите по-английски",
    "Ruscha yozing": "Напишите по-русски",
    "Eshiting va inglizcha yozing": "Послушайте и напишите по-английски",
    "Eshiting va ruscha yozing": "Послушайте и напишите по-русски",
    "Yana bir bor: *": "Ещё раз: @1",
    "Eshitish": "Прослушать",
    "Sekin": "Медленно",
    "# ta harf": "$1 {буква|буквы|букв}",
    "* · # ta harf": "@1 · $2 {буква|буквы|букв}",
    "Javobingiz": "Ваш ответ",
    "Javob, # ta harf": "Ответ, $1 {буква|буквы|букв}",
    "Katakka bosib yozishni boshlang": "Нажмите на клетку и начните писать",
    "Imlo: *": "Орфография: $1",
    "Soʻzni ovoz chiqarib ayting": "Произнесите слово вслух",
    "Namunani tinglash": "Послушать образец",
    "Bosing va gapiring": "Нажмите и говорите",
    "Gapirish": "Говорить",
    "Hozir gapira olmayman": "Сейчас не могу говорить",
    "Bu sahifada mikrofon ishlamaydi, shuning uchun talaffuz eshitib tanlash orqali tekshiriladi. Mobil ilovada ovozingiz tekshiriladi.": "На этой странице микрофон не работает, поэтому произношение проверяется выбором на слух. В мобильном приложении будет проверяться ваш голос.",
    "Qayta eshitish": "Послушать ещё",
    "* — tugmani bosib, yana eshiting": "$1 — нажмите, чтобы послушать ещё",
    "Eshitilmadi. Yana bosib, aniqroq ayting": "Не расслышали. Нажмите ещё раз и скажите чётче",
    "Eshitilmadi. Mikrofon ruxsatini tekshiring yoki “Hozir gapira olmayman”ni bosing": "Не расслышали. Проверьте доступ к микрофону или нажмите «Сейчас не могу говорить»",
    "Yana urinib koʻring": "Попробуйте ещё раз",
    "Siz aytdingiz: *": "Вы сказали: $1",
    "Barakalla!": "Отлично!",
    "Toʻgʻri javob:": "Правильный ответ:",
    "+# XP": "+$1 XP",
    "Bu soʻz shu bosqich oxirida yana chiqadi. Hamma soʻzlar toʻgʻri topilgach, keyingi bosqichga oʻtasiz.": "Это слово появится ещё раз в конце этапа. Когда все слова будут верны, перейдёте к следующему этапу.",
    "Bu soʻz oxirida yana chiqadi.": "Это слово появится ещё раз в конце.",
    "Toʻgʻrisi: * *. Bu soʻz shu bosqich oxirida yana chiqadi.": "Правильно: $1 $2. Это слово появится ещё раз в конце этапа.",
    "Hamma soʻzlarni bilasiz — dars yakunlandi": "Вы знаете все слова — урок завершён",
    "Dars tugadi!": "Урок окончен!",
    "Mashq tugadi!": "Тренировка окончена!",
    "Kunlik maqsad bajarildi!": "Дневная цель выполнена!",
    "Test: #/#": "Тест: $1/$2",
    "Qiyin soʻzlar: #/#": "Трудные слова: $1/$2",
    "Xatolar ustida ishlash: #/#": "Работа над ошибками: $1/$2",
    "yangi + takror": "новые + повтор",
    "savol": "вопросов",
    "aniqlik": "точность",
    "kun streak": "дней подряд",
    "# kunlik streak": "$1 {день|дня|дней} подряд",
    "Bugun oʻrganildi": "Изучено сегодня",
    "Mashq qilingan soʻzlar": "Слова тренировки",
    "# ta xato · Qayta ishlash": "Ошибок: $1 · Повторить",
    "Natijani nusxalash": "Скопировать результат",
    "Natija nusxalandi": "Результат скопирован",
    "Bosh sahifaga": "На главную",
    "MAX": "MAX",
    "Podkastlar": "Подкасты",
    "Kitoblar": "Книги",
    "Kino-takror": "Кино-повтор",
    "#+ epizod": "$1+ эпизодов",
    "# ta kitob": "$1 книг",
    "# sahna": "$1 сцен",
    "HAFTANING KITOBI": "КНИГА НЕДЕЛИ",
    "Oʻqishni boshlash": "Начать чтение",
    "Davom ettiring": "Продолжите",
    "Kitob · #-bob": "Книга · глава $1",
    "Podkast · #:# / #:#": "Подкаст · $1:$2 / $3:$4",
    "Kino-takror · #/# gap": "Кино-повтор · $1/$2 фраз",
    "Tariflarni solishtirish": "Сравнить тарифы",
    "Bepul · Pro · Max": "Бесплатно · Pro · Max",
    "Test versiyada bu boʻlim namuna sifatida koʻrsatilgan — Max tarifda ochiladi.": "В тестовой версии раздел показан как пример — откроется в тарифе Max.",
    "Qidiruv Max tarifda ochiladi": "Поиск откроется в тарифе Max",
    "Lexo Radio": "Lexo Radio",
    "Kitob javoni": "Книжная полка",
    "Darajali kitoblar": "Книги по уровням",
    "Shadowing": "Shadowing",
    "Darajangizga mos qisqa podkastlar. Subtitr bilan tinglang, tezlikni sekinlashtiring, notanish soʻzni bosib lugʻatingizga qoʻshing.": "Короткие подкасты по вашему уровню. Слушайте с субтитрами, замедляйте, добавляйте незнакомые слова в словарь одним нажатием.",
    "Mashhur asarlarning darajangizga moslashtirilgan versiyalari. Audio bilan birga oʻqing, har bob oxirida yangi soʻzlarni yodlang.": "Известные произведения, адаптированные под ваш уровень. Читайте с аудио и учите новые слова после каждой главы.",
    "Filmlardan qisqa sahnalarni koʻring va qahramon bilan bir vaqtda takrorlang. Talaffuz, urgʻu va ohangni tabiiy holda oʻrganasiz.": "Смотрите короткие сцены из фильмов и повторяйте вместе с героем. Произношение, ударение и интонация — естественно.",
    "Subtitr va oʻzbekcha tarjima": "Субтитры и узбекский перевод",
    "#.#× sekin ijro": "Замедление $1.$2×",
    "Soʻzni bosib kartochkaga qoʻshish": "Добавление слова в карточку нажатием",
    "Har epizod oxirida # savollik test": "Тест из $1 вопросов после каждого эпизода",
    "A# dan B# gacha moslashtirilgan matn": "Адаптированный текст от A$1 до B$2",
    "A# dan B# gacha moslashtirilgan matn (urgʻu belgilari bilan)": "Адаптированный текст от A$1 до B$2 (с ударениями)",
    "Diktor ovozi bilan oʻqish": "Чтение с голосом диктора",
    "Soʻzni bosib tarjima": "Перевод слова по нажатию",
    "Bob oxirida soʻzlar mashqi": "Упражнение на слова после главы",
    "#–# soniyalik sahnalar": "Сцены по $1–$2 секунд",
    "Gapma-gap takrorlash": "Повтор фраза за фразой",
    "Ovozingizni yozib, asl bilan solishtirish": "Запись голоса и сравнение с оригиналом",
    "Talaffuz bahosi": "Оценка произношения",
    "Namuna roʻyxat": "Пример списка",
    "Max tarifda ochiladi": "Откроется в тарифе Max",
    "# daq": "$1 мин",
    "# bet": "$1 стр.",
    "# soniya": "$1 сек",
    "Salomlashish va tanishuv": "Приветствие и знакомство",
    "Doʻkonda xarid": "Покупки в магазине",
    "Sayohatdagi kun": "День в путешествии",
    "Ob-havo va fasllar": "Погода и времена года",
    "Ish suhbatiga tayyorgarlik": "Подготовка к собеседованию",
    "Shahar hayoti haqida suhbat": "Разговор о жизни в городе",
    "Kafedagi suhbat": "Разговор в кафе",
    "Kundalik suhbat · kafeda": "Повседневный разговор · в кафе",
    "Ochiq litsenziyali animatsion film · #-sahna": "Мультфильм с открытой лицензией · сцена $1",
    "Ilmiy-fantastik qisqa film · #-sahna": "Короткометражная фантастика · сцена $1",
    "Klassik film · tanishuv sahnasi": "Классический фильм · сцена знакомства",
    "The Little Red Hen · xalq ertagi": "The Little Red Hen · народная сказка",
    "Sherlock Holmes hikoyalari · A. Conan Doyle": "Рассказы о Шерлоке Холмсе · А. Конан Дойл",
    "Ochiq litsenziyali multfilm (rus tilida) · #-sahna": "Мультфильм с открытой лицензией · сцена $1",
    "Знакомство · tanishuv": "Знакомство",
    "В магазине · doʻkonda": "В магазине",
    "Поездка в Самарканд · sayohat": "Поездка в Самарканд",
    "Разговор в кафе · kundalik suhbat": "Разговор в кафе",
    "На вокзале · chipta olish": "На вокзале",
    "Репка · xalq ertagi": "Репка · народная сказка",
    "Колобок · xalq ertagi": "Колобок · народная сказка",
    "Филиппок · L. N. Tolstoy": "Филиппок · Л. Н. Толстой",
    "Каштанка · A. P. Chexov": "Каштанка · А. П. Чехов",
    "Капитанская дочка · A. S. Pushkin": "Капитанская дочка · А. С. Пушкин",
    "A. P. Chexov · A# · # bet": "А. П. Чехов · A$1 · $2 стр.",
    "Oscar Wilde · A# · # bet": "Оскар Уайльд · A$1 · $2 стр.",
    "Tariflar": "Тарифы",
    "Tarifingiz": "Ваш тариф",
    "Solishtirish ›": "Сравнить ›",
    "Bepul": "Бесплатно",
    "soʻm/oy": "сум/мес",
    "# soʻm": "$1 сум",
    "# soʻm / oy": "$1 сум / мес",
    "# soʻz": "$1 {слово|слова|слов}",
    "# ta soʻz": "$1 {слово|слова|слов}",
    "Cheklanmagan soʻzlar · barcha oʻyinlar · kartochkalar · statistika": "Безлимит слов · все игры · карточки · статистика",
    "Pro’dagi hammasi + podkastlar, kitoblar, kino-takror": "Всё из Pro + подкасты, книги, кино-повтор",
    "Kuniga # ta yangi soʻz": "$1 новых слов в день",
    "Takrorlash cheksiz": "Повторение без ограничений",
    "Asosiy mashqlar": "Основные упражнения",
    "Cheklanmagan soʻzlar": "Безлимит слов",
    "Barcha oʻyinlar": "Все игры",
    "Kartochkalar va qiyin soʻzlar": "Карточки и трудные слова",
    "Batafsil statistika": "Подробная статистика",
    "Pro’dagi hamma narsa": "Всё, что есть в Pro",
    "Lexo Radio — podkastlar": "Lexo Radio — подкасты",
    "Kitob javoni — darajali kitoblar": "Книжная полка — книги по уровням",
    "Kino-takror — shadowing": "Кино-повтор — shadowing",
    "Talaffuz tahlili": "Анализ произношения",
    "Eng toʻliq": "Самый полный",
    "Narxlar taxminiy. Test versiyada toʻlov yoʻq.": "Цены ориентировочные. В тестовой версии оплаты нет.",
    "Maxʼni sinab koʻrish": "Попробовать Max",
    "Test versiyada toʻlov yoʻq — toʻliq ilovada ochiladi": "В тестовой версии оплаты нет — будет в полном приложении",
    "Yodlangan": "Выучено",
    "Kunlik streak": "Дней подряд",
    "Aniqlik": "Точность",
    "Shu hafta": "Эта неделя",
    "Yangi": "Новые",
    "Takrorlash": "Повторение",
    "* yangi, * takror": "$1 новых, $2 повтор.",
    "Sozlamalar": "Настройки",
    "* · # soʻz/kun": "$1 · $2 слов/день",
    "Soʻrovnoma javoblarim": "Мои ответы на опрос",
    "Ingliz tili · A# · test versiya": "Английский · A$1 · тестовая версия",
    "Rus tili · A# · test versiya": "Русский · A$1 · тестовая версия",
    "Oʻrganish usuli": "Способ обучения",
    "Mustaqil": "Самостоятельно",
    "Kunlik maqsad": "Дневная цель",
    "Test vositalari": "Тестовые инструменты",
    "Ertangi kunga oʻtish": "Перейти на завтра",
    "+# kun": "+$1 дн.",
    "Haqiqiy sanaga qaytish": "Вернуться к реальной дате",
    "Bir kun oldinga surildi": "Сдвинуто на день вперёд",
    "Maʼlumotlarni boshqarish": "Управление данными",
    "Ingliz tili boʻyicha butun progress (soʻzlar, XP, streak, kartochkalar) oʻchiriladi. Buni qaytarib boʻlmaydi.": "Весь прогресс по английскому (слова, XP, серия, карточки) будет удалён. Это нельзя отменить.",
    "Rus tili boʻyicha butun progress (soʻzlar, XP, streak, kartochkalar) oʻchiriladi. Buni qaytarib boʻlmaydi.": "Весь прогресс по русскому (слова, XP, серия, карточки) будет удалён. Это нельзя отменить.",
    "Progressni tozalash": "Сбросить прогресс",
    "Progress faqat shu brauzerda saqlanadi. “Ertangi kunga oʻtish” takrorlash jadvalini kutmasdan sinash uchun.": "Прогресс хранится только в этом браузере. «Перейти на завтра» — чтобы проверить повторения без ожидания.",
    "Ingliz tili boʻyicha # ta soʻz, # XP va streak oʻchiriladi. Tasdiqlash uchun pastga": "Будут удалены $1 {слово|слова|слов} по английскому, $2 XP и серия. Для подтверждения введите",
    "Rus tili boʻyicha # ta soʻz, # XP va streak oʻchiriladi. Tasdiqlash uchun pastga": "Будут удалены $1 {слово|слова|слов} по русскому, $2 XP и серия. Для подтверждения введите",
    "deb yozing.": "ниже.",
    "Progress tozalandi": "Прогресс сброшен",
    "Ovoz topilmadi": "Голос не найден",
    "Ingliz tili ovozi topilmadi": "Английский голос не найден",
    "Rus tili ovozi topilmadi": "Русский голос не найден",
    "Qurilmangizda rus tili ovozi oʻrnatilmagan, shuning uchun soʻzlar notoʻgʻri talaffuz qilinmasligi uchun ovoz oʻchirildi. Oʻrnating:": "На устройстве не установлен русский голос, поэтому звук отключён, чтобы слова не произносились неправильно. Установите:",
    "Qurilmangizda ingliz tili ovozi oʻrnatilmagan, shuning uchun soʻzlar notoʻgʻri talaffuz qilinmasligi uchun ovoz oʻchirildi. Oʻrnating:": "На устройстве не установлен английский голос, поэтому звук отключён, чтобы слова не произносились неправильно. Установите:",
    "Sozlamalar → Til va kiritish → Matnni nutqqa → Google → Русский ovozini yuklab oling": "Настройки → Язык и ввод → Синтез речи → Google → скачайте голос «Русский»",
    "Sozlamalar → Til va kiritish → Matnni nutqqa → Google → English ovozini yuklab oling": "Настройки → Язык и ввод → Синтез речи → Google → скачайте голос «English»",
    "Sozlamalar → Vaqt va til → Nutq → Ovoz qoʻshish → Русский": "Параметры → Время и язык → Речь → Добавить голоса → Русский",
    "Sozlamalar → Vaqt va til → Nutq → Ovoz qoʻshish → English": "Параметры → Время и язык → Речь → Добавить голоса → English",
    "• Yoki sahifani": "• Или откройте страницу в",
    "da oching — unda rus ovozi tayyor boʻladi": "— там русский голос обычно уже есть",
    "da oching — unda ingliz ovozi tayyor boʻladi": "— там английский голос обычно уже есть",
    "Qoʻngʻiroqcha": "Колокольчик",
    "Bitta tiniq zang": "Один чистый звон",
    "Ikki tez “ding”": "Два быстрых «динь»",
    "Uch notali arpedjio": "Арпеджио из трёх нот",
    "Yumshoq, iliq ikki nota": "Две мягкие тёплые ноты",
    "# ta takrorlash kutyapti": "Ждут повторения: $1",
    "# ta xato": "Ошибок: $1",
    "#-raund": "Раунд $1",
    "#/# yodlangan": "Выучено $1/$2",
    "1 ga 1 bellashuv": "Поединок 1 на 1",
    "1 ga 1 · doʻst, raqib yoki bot": "1 на 1 · друг, соперник или бот",
    "3–16 belgi: lotin harflari, raqam va _ . Reytingda va janglarda shu nom koʻrinadi.": "3–16 символов: латинские буквы, цифры и _. Это имя видно в рейтинге и битвах.",
    "7 kun": "7 дней",
    "Aniqlik ~#% · javob ~# soniyada": "Точность ~$1% · ответ за ~$2 с",
    "Avatar": "Аватар",
    "Avatar ramkasi": "Рамка аватара",
    "Avatar saqlandi": "Аватар сохранён",
    "Avatar yasash": "Создать аватар",
    "Avatarni olib tashlash": "Удалить аватар",
    "Avatarni oʻzgartirish": "Изменить аватар",
    "Barcha oʻquvchilar": "Все ученики",
    "Binafsha": "Фиолетовая",
    "Birinchi darsni tugating": "Завершите первый урок",
    "Birinchi qadam": "Первый шаг",
    "Bot qiyinligini tanlang": "Выберите сложность бота",
    "Boʻsh kataklarni toʻldiring": "Заполните пустые клетки",
    "Bu safar raqib yutdi": "В этот раз победил соперник",
    "Bu shakl shu bosqich oxirida yana chiqadi.": "Эта форма появится ещё раз в конце этапа.",
    "Bugun takrorlash yoʻq": "Сегодня нечего повторять",
    "Bugungi darsni qilsangiz, streak davom etadi.": "Пройдите урок сегодня, чтобы серия продолжилась.",
    "Doʻstingiz kutilmoqda…": "Ждём друга…",
    "Doʻstingizni taklif qiling": "Пригласите друга",
    "Durang": "Ничья",
    "Eshiting va raqamda yozing": "Слушайте и пишите цифрами",
    "Feʼl juftlari": "Видовые пары глаголов",
    "Feʼl ustasi": "Мастер глаголов",
    "Galereyadan tanlash": "Выбрать из галереи",
    "Gʻalaba!": "Победа!",
    "Harflarni barmoq bilan ilondek bogʻlab soʻz yasang": "Соединяйте буквы пальцем змейкой, чтобы составить слово",
    "Harflarni bogʻlab soʻz toping": "Соединяйте буквы в слова",
    "Havola nusxalandi": "Ссылка скопирована",
    "Havola yuboring — doʻstingiz qoʻshiladi": "Отправьте ссылку — друг присоединится",
    "Hozir takrorlasangiz, ular uzoq xotiraga oʻtadi.": "Повторите сейчас — и они перейдут в долгую память.",
    "Ism": "Имя",
    "Istisno: boshqa soʻz": "Исключение: другое слово",
    "Jang boshlanmoqda…": "Битва начинается…",
    "Jangchi": "Боец",
    "Javob — Enter": "Ответ — Enter",
    "Jiddiy": "Серьёзно",
    "Jingalak": "Кудри",
    "Kepka": "Кепка",
    "Keyingi son": "Следующее число",
    "Koʻz qisgan": "Подмигивает",
    "Koʻzoynak": "Очки",
    "Kulgan": "Смеются",
    "Kulgi": "Смех",
    "Lexo afsonasi": "Легенда Lexo",
    "Lugʻat bilimdoni": "Знаток словаря",
    "Masalan: Har kuni 10 ta soʻz!": "Например: 10 слов каждый день!",
    "Mashq oʻyinlari": "Тренировочные игры",
    "Mashq qilingan shakllar": "Отработанные формы",
    "Mashqni boshlash": "Начать тренировку",
    "Natija": "Результат",
    "Natijalar": "Результаты",
    "Nickname": "Никнейм",
    "Nickname 3–16 belgidan iborat boʻlsin: a–z, 0–9, _": "Никнейм: 3–16 символов, a–z, 0–9, _",
    "Notoʻgʻri feʼllar": "Неправильные глаголы",
    "Nuqta": "Точки",
    "Old qoʻshimcha bilan": "С приставкой",
    "Olov": "Огонь",
    "Oltin": "Золотая",
    "Oson, oʻrta yoki qiyin raqib": "Лёгкий, средний или сложный соперник",
    "Profil saqlandi": "Профиль сохранён",
    "Profilni tahrirlash": "Редактировать профиль",
    "Qayta urinib koʻring": "Попробуйте ещё раз",
    "Qisqa": "Короткие",
    "Qiyinlikni tanlang": "Выберите сложность",
    "Qoʻshimcha oʻzgaradi": "Меняется суффикс",
    "Quloqchin": "Наушники",
    "Raqib qidirilmoqda…": "Ищем соперника…",
    "Rekord #/#": "Рекорд $1/$2",
    "Roʻmol": "Платок",
    "Roʻyxat · #": "Список · $1",
    "Saqlash": "Сохранить",
    "Shaftoli": "Персиковая",
    "Shakl zanjiri": "Цепочка форм",
    "Shior (ixtiyoriy)": "Девиз (необязательно)",
    "Sonlar": "Числа",
    "Sonlar: #/#": "Числа: $1/$2",
    "Sonni raqamda yozing": "Запишите число цифрами",
    "Soʻz ilon": "Змейка слов",
    "Soʻz izlovchi": "Искатель слов",
    "Soʻz jangi": "Битва слов",
    "Soʻz jangida gʻalaba": "Победа в битве слов",
    "Soʻz ovchisi": "Охотник за словами",
    "Soʻz shakllari": "Формы слов",
    "Soʻz shakllariga": "К формам слов",
    "Soʻz ustasi": "Мастер слов",
    "Surat yuklash": "Загрузить фото",
    "Tabassum": "Улыбка",
    "Taklif kodi": "Код приглашения",
    "Taymer son aytib boʻlingach boshlanadi. Sonni yana bir marta eshitish mumkin, lekin vaqt toʻxtamaydi.": "Таймер стартует после того, как число произнесено. Можно прослушать ещё раз, но время не останавливается.",
    "Tayyor": "Готово",
    "Tez quloq": "Быстрый слух",
    "Til darajasi": "Уровень языка",
    "Tinglang…": "Слушайте…",
    "Toj": "Корона",
    "Toʻgʻri:": "Верно:",
    "Tugallanmagan (jarayon) – tugallangan (natija)": "Несовершенный (процесс) – совершенный (результат)",
    "Tugun": "Пучок",
    "Uzun": "Длинные",
    "V1 – V2 (Past Simple) – V3 (Past Participle)": "V1 – V2 (Past Simple) – V3 (Past Participle)",
    "V2 — oʻtgan zamon (Past Simple), V3 — have/has + V3 (Present Perfect).": "V2 — прошедшее время (Past Simple), V3 — have/has + V3 (Present Perfect).",
    "Vaqt tugadi": "Время вышло",
    "XP boyvachchasi": "XP-богач",
    "Xatosiz": "Без ошибок",
    "YANGI SHAKL · #/#": "НОВАЯ ФОРМА · $1/$2",
    "Yangi boshlovchi": "Новичок",
    "Yashil": "Зелёная",
    "Yon tarash": "Набок",
    "Yordam": "Подсказка",
    "Yozing!": "Пишите!",
    "Yoʻq": "Нет",
    "Yutuqlar": "Достижения",
    "rekord": "рекорд",
    "takrorlash": "повторение",
    "toʻgʻri": "верно",
    "yangi": "новые",
    "yodlangan": "выучено",
    "НСВ · jarayon": "НСВ · процесс",
    "НСВ — jarayon, takrorlanish (“qilardim”); СВ — bir martalik natija (“qilib boʻldim”).": "НСВ — процесс, повторение; СВ — однократный результат.",
    "СВ · natija": "СВ · результат",
    "# juft": "$1 пар",
    "# soʻz/kun": "$1 {слово|слова|слов}/день",
    "# ta son, vaqt cheklangan.": "$1 чисел, время ограничено.",
    "# xonali sonlar": "$1-значные числа",
    "#–# xonali sonlar": "$1–$2-значные числа",
    "#/# toʻgʻri": "$1/$2 верно",
    "#/# oʻrganildi": "$1/$2 изучено",
    "7 raund · tez va toʻgʻri javob yutadi · gʻalaba +# XP": "7 раундов · побеждает быстрый и верный ответ · победа +$1 XP",
    "Avatar olib tashlandi": "Аватар удалён",
    "Bu jang band": "Эта битва уже занята",
    "Bu nickname band — boshqasini tanlang": "Этот никнейм занят — выберите другой",
    "Doʻst va tasodifiy raqib bilan jang navbatma-navbat: har kim oʻz vaqtida oʻynaydi, natija ikkalasi oʻynagach chiqadi.": "Битва с другом и случайным соперником идёт по очереди: каждый играет в своё время, результат появится, когда сыграют оба.",
    "Doʻstingiz hali qoʻshilmadi": "Друг ещё не присоединился",
    "Eng kerakli soʻzlar": "Самые нужные слова",
    "Havolani yuboring va hozir oʻynang — doʻstingiz keyin sizning natijangizga qarshi oʻynaydi.": "Отправьте ссылку и играйте сейчас — друг потом сыграет против вашего результата.",
    "Havolani yuborish": "Отправить ссылку",
    "Hozir onlayn raqib yoʻq": "Сейчас нет соперника онлайн",
    "Hozir oʻynash": "Играть сейчас",
    "Jang topilmadi": "Битва не найдена",
    "Javob bering": "Ответьте",
    "Keyingi unvon": "Следующее звание",
    "Natijani yuborib boʻlmadi": "Не удалось отправить результат",
    "Oʻynang — natijangizni keyingi raqib koʻradi, natija kelganda xabar beramiz.": "Играйте — ваш результат увидит следующий соперник, мы сообщим, когда будет итог.",
    "Oʻynash": "Играть",
    "Qayta yuborish": "Отправить снова",
    "Qiyin #/10": "Сложно $1/10",
    "Raqib": "Соперник",
    "Raqib keyinroq oʻynaydi": "Соперник сыграет позже",
    "Raqib natijasi kutilmoqda": "Ждём результат соперника",
    "Raqibingiz oʻynagach natija chiqadi — xabar beramiz.": "Итог появится, когда сыграет соперник — мы сообщим.",
    "Rasm kvadrat qilib qirqiladi va 256×256 px ga kichraytiriladi.": "Фото обрезается до квадрата и уменьшается до 256×256 px.",
    "Rasmni ochib boʻlmadi": "Не удалось открыть изображение",
    "Reyting barcha Lexo oʻquvchilari orasida. Haftalik reyting har dushanba yangilanadi.": "Рейтинг среди всех учеников Lexo. Недельный рейтинг обновляется каждый понедельник.",
    "Saqlab boʻlmadi — internetni tekshiring": "Не удалось сохранить — проверьте интернет",
    "Siz yozdingiz:": "Вы написали:",
    "Sizni jangga chaqirishdi": "Вас вызвали на битву",
    "Sonlar · Qiyin: 8/10": "Числа · Сложно: 8/10",
    "Soʻz jangida men bilan bellashing!": "Сразитесь со мной в Битве слов!",
    "Soʻz jangida raqiblar shu daraja boʻyicha tanlanadi. Hozircha soʻzlar A1 toʻplamidan.": "В Битве слов соперники подбираются по этому уровню. Пока слова из набора A1.",
    "Tezkor 60": "Быстрые 60",
    "V2 · Past": "V2 · Past",
    "V3 · Participle": "V3 · Participle",
    "Yana bir bor: ": "Ещё раз: ",
    "Yuklanmoqda…": "Загрузка…",
    "darajadagi onlayn oʻyinchilar orasidan": "среди игроков онлайн уровня",
    "darajadagi oʻyinchilar": "игроки уровня",
    "javob berdi": "ответил(а)",
    "keyinroq oʻynaydi": "сыграет позже",
    "oʻylayapti…": "думает…",
    "oʻynagach natija chiqadi — xabar beramiz.": "сыграет — появится итог, мы сообщим.",
    "qoʻshildi!": "присоединился(ась)!",
    "siz": "вы",
    "Faqat": "Только",
    "Oldingi": "Предыдущее",
    "ega boʻlmoq": "иметь",
    "gapirib bermoq": "рассказывать",
    "hal qilmoq": "решать",
    "izlamoq → topmoq": "искать → найти",
    "javob bermoq": "отвечать",
    "ketmoq, qoldirmoq": "уходить, оставлять",
    "olib kelmoq": "приносить",
    "olmoq (erishmoq)": "получать (достигать)",
    "olmoq (qabul qilmoq)": "получать (принимать)",
    "olmoq (qoʻlga)": "брать (в руки)",
    "qoʻngʻiroq qilmoq": "звонить",
    "sotib olmoq": "покупать",
    "turmoq (oʻrnidan)": "вставать",
    "yordam bermoq": "помогать",
    "Oʻrtadan yuqori": "Выше среднего",
    "Ilgʻor": "Продвинутый",
    "Mukammal": "Профессиональный",
    "Tanlash": "Выбрать",
    "Yana # ta soʻz — qidiruv bilan toraytiring": "Ещё $1 слов — уточните поиском",
    "Ingliz → oʻzbek": "Английский → узбекский",
    "Rus → oʻzbek": "Русский → узбекский",
    "Har kuni 10 daqiqa — soʻz boyligingiz oʻsib boradi.": "10 минут в день — и ваш словарный запас растёт.",
    "Darslar shu darajadagi soʻzlardan boshlanadi, soʻz jangida raqiblar ham shu daraja boʻyicha tanlanadi. Keyin Toʻplamlar boʻlimida almashtirish mumkin.": "Уроки начнутся со слов этого уровня, соперники в Битве слов тоже подбираются по нему. Позже уровень можно сменить в разделе «Наборы».",
    "Oʻyinlar oʻrganilgan soʻzlaringizdan tuziladi (kamida 6 ta boʻlmasa — barcha soʻzlardan).": "Игры строятся из изученных слов (если их меньше 6 — из всех слов).",
    "Kunlik maqsad (yangi soʻz)": "Дневная цель (новых слов)",
    "Har dars shuncha yangi soʻz beradi, takrorlashlar bunga qoʻshimcha. Keyin Sozlamalarda 3 dan 10 gacha oʻzgartirish mumkin.": "Каждый урок даёт столько новых слов, повторения идут дополнительно. Потом в Настройках можно изменить от 3 до 10.",
    "Fikr va takliflar": "Отзывы и предложения",
    "Loyihani qoʻllab-quvvatlash": "Поддержать проект",
    "Lexo bepul va reklamasiz. Loyiha rivoji uchun istalgan summa bilan qoʻllab-quvvatlashingiz mumkin:": "Lexo бесплатен и без рекламы. Вы можете поддержать развитие проекта любой суммой:",
    "Karta raqamini nusxalash": "Скопировать номер карты",
    "Karta raqami nusxalandi": "Номер карты скопирован",
    "Rahmat! 💜 Karta raqami Profil boʻlimida ham turadi.": "Спасибо! 💜 Номер карты есть и в разделе Профиль.",
    "Keyinroq": "Позже",
    "Muammo": "Проблема",
    "Taklif": "Предложение",
    "Biz har bir fikrni oʻqiymiz. Nima haqida yozmoqchisiz?": "Мы читаем каждый отзыв. О чём хотите написать?",
    "Fikringiz, taklifingiz yoki duch kelgan muammo…": "Ваш отзыв, предложение или проблема…",
    "Yuborish": "Отправить",
    "Kamida 3 ta belgi yozing": "Напишите хотя бы 3 символа",
    "Rahmat! Fikringiz yuborildi": "Спасибо! Отзыв отправлен",
    "Bugun yetarli — rahmat! Ertaga davom etamiz": "На сегодня достаточно — спасибо! Продолжим завтра",
    "Yuborib boʻlmadi — internetni tekshiring": "Не удалось отправить — проверьте интернет",
    "# ta boshlangan": "начато $1",
    "Barcha soʻzlardan": "Из всех слов",
    "Bugungi reja bajarildi — ertaga davom etamiz": "План на сегодня выполнен — продолжим завтра",
    "Ertaga yana # ta yangi soʻz": "Завтра ещё $1 {новое слово|новых слова|новых слов}",
    "Bu soʻz keyingi darslarda qayta oʻrganiladi": "Это слово повторим в следующих уроках"
  },
  "en": {
    "Bosh sahifa": "Home",
    "Toʻplamlar": "Sets",
    "Oʻyinlar": "Games",
    "Kutubxona": "Library",
    "Profil": "Profile",
    "Orqaga": "Back",
    "Yopish": "Close",
    "Chiqish": "Exit",
    "Qidirish": "Search",
    "Bildirishnomalar": "Notifications",
    "Tilni almashtirish": "Change language",
    "Tilni tanlang": "Choose language",
    "Davom etish": "Continue",
    "Lexo Telegram ichida ishlaydi": "Lexo works inside Telegram",
    "Ilovani Telegram botidan oching — progressingiz Telegram hisobingizga bogʻlanadi va hech qachon yoʻqolmaydi.": "Open the app from the Telegram bot — your progress is tied to your Telegram account and is never lost.",
    "Telegramʼda ochish": "Open in Telegram",
    "Server bilan aloqa yoʻq": "No connection to the server",
    "Internetni tekshiring va qayta urinib koʻring.": "Check your internet and try again.",
    "Qayta urinish": "Retry",
    "Tushunarli": "Got it",
    "Bekor qilish": "Cancel",
    "Oʻchirish": "Delete",
    "Tekshirish": "Check",
    "Keyingi": "Next",
    "Yana": "Again",
    "Boshlash": "Start",
    "Tez orada": "Coming soon",
    "Hammasi": "All",
    "Barchasi": "All",
    "Boshqa": "Other",
    "test": "test",
    "Test": "Test",
    "Xayrli tong": "Good morning",
    "Xayrli kun": "Good afternoon",
    "Xayrli kech": "Good evening",
    "Xayrli tun": "Good night",
    "Lexo oʻquvchisi": "Lexo learner",
    "Lexo foydalanuvchisi": "Lexo user",
    "Lexo v# test": "Lexo v$1 test",
    "Du": "Mo",
    "Se": "Tu",
    "Ch": "We",
    "Pa": "Th",
    "Ju": "Fr",
    "Sh": "Sa",
    "Ya": "Su",
    "Ingliz tili": "English",
    "Rus tili": "Russian",
    "Ingliz": "English",
    "Rus": "Russian",
    "Ingliz → oʻzbek · # soʻz (test)": "English → Uzbek · $1 {word|words} (test)",
    "Rus → oʻzbek · # soʻz (test)": "Russian → Uzbek · $1 {word|words} (test)",
    "Qaysi tilni oʻrganasiz?": "Which language are you learning?",
    "Har bir tilning progressi alohida saqlanadi.": "Progress is saved separately for each language.",
    "Ilova tili": "App language",
    "Oʻrganilayotgan til": "Learning language",
    "Lexoʼga xush kelibsiz": "Welcome to Lexo",
    "Har kuni # daqiqa — soʻz boyligingiz oʻsib boradi. Bu # soʻzlik test versiya.": "$1 minutes a day and your vocabulary keeps growing. This is a $2-word test version.",
    "Ismingiz": "Your name",
    "Bittasini tanlang.": "Choose one.",
    "#-savol": "Question $1",
    "Javobni tanlang": "Choose an answer",
    "Lexo haqida qayerdan eshitdingiz?": "How did you hear about Lexo?",
    "Tanishim / Yaqinim": "Friend / family",
    "Oʻquv markazi": "Learning center",
    "Google qidiruv": "Google search",
    "Yoshingiz nechada?": "How old are you?",
    "# dan kichik": "Under $1",
    "# va undan katta": "$1 and older",
    "Hozir nima bilan bandsiz?": "What do you do now?",
    "Maktab oʻquvchisi": "School student",
    "Talaba": "University student",
    "Ishlayman": "Working",
    "Ishlamayman / uydaman": "Not working / at home",
    "Bu til sizga nima uchun kerak?": "Why do you need this language?",
    "IELTS / CEFR imtihoni": "IELTS / CEFR exam",
    "Chet elda oʻqish": "Studying abroad",
    "Ish / karyera": "Work / career",
    "Sayohat": "Travel",
    "Oʻzim uchun": "For myself",
    "Qanday oʻrganasiz?": "How do you study?",
    "Mustaqil oʻrganaman": "On my own",
    "Lexo soʻzlarni oʻzi tanlab, tasodifiy tartibda beradi": "Lexo picks words for you in random order",
    "Oʻquv markazida oʻqiyman": "At a learning center",
    "Har darsdagi soʻzlarni oʻz kartochkangizga qoʻshib oʻrganasiz": "Add each lesson's words to your own cards",
    "Oʻquv markazi nomi (ixtiyoriy)": "Learning center name (optional)",
    "Ingliz tilini qanchalik bilasiz?": "How well do you know English?",
    "Rus tilini qanchalik bilasiz?": "How well do you know Russian?",
    "Shunga mos soʻzlardan boshlaymiz.": "We'll start with matching words.",
    "Shunga qarab darslar tartibini moslaymiz.": "We'll adjust the lesson order to this.",
    "Noldan boshlayman": "Starting from zero",
    "Oddiy gaplarni tushunaman": "I understand simple phrases",
    "Bemalol gaplasha olaman": "I can speak freely",
    "Kuniga nechta yangi soʻz?": "How many new words a day?",
    "≈ # daqiqa · Yengil": "≈ $1 min · Easy",
    "≈ # daqiqa · Meʼyorida": "≈ $1 min · Regular",
    "≈ # daqiqa · Jiddiy": "≈ $1 min · Serious",
    "≈ # daqiqa · Intensiv": "≈ $1 min · Intense",
    "BUGUNGI DARS": "TODAY'S LESSON",
    "# ta soʻz qoldi": "$1 {word|words} left",
    "Maqsad bajarildi!": "Goal reached!",
    "Bugungi reja bajarildi": "Today's plan is done",
    "Takrorlash kunlarini kuting": "Wait for review days",
    "+ # ta takrorlash": "+ $1 {review|reviews}",
    "Kartochkadan ·": "From card ·",
    "Kartochkadan · + # ta takrorlash": "From card · + $1 {review|reviews}",
    "Darsni boshlash": "Start lesson",
    "Darsni davom ettirish": "Continue lesson",
    "Bugun tugadi": "Done for today",
    "Dars kartochkasi": "Lesson card",
    "Ixtiyoriy: darsdagi soʻzlarni qoʻshing": "Optional: add words from class",
    "Joriy kartochka · #/# oʻrganildi": "Current card · $1/$2 learned",
    "Takrorlash vaqti": "Time to review",
    "# ta soʻz kutyapti": "$1 {word|words} waiting",
    "Hozircha takrorlash yoʻq": "Nothing to review yet",
    "Qiyin soʻzlar": "Difficult words",
    "# ta belgilangan": "$1 marked",
    "Yulduzcha bilan belgilang": "Mark with a star",
    "Jonli ingliz tili": "Live English",
    "Jonli rus tili": "Live Russian",
    "# kun": "$1 {day|days}",
    "# XP": "$1 XP",
    "#-oʻrin": "#$1",
    "Takrorlash kuni kelgan soʻz yoʻq": "No words due for review",
    "Soʻz kartochkasidagi yulduzchani bosib belgilang": "Tap the star on a word card",
    "# ta soʻz takrorlashni kutyapti": "$1 {word|words} waiting for review",
    "Yangi bildirishnoma yoʻq": "No new notifications",
    "Eslatmalar mobil ilovada boʻladi.": "Reminders will be in the mobile app.",
    "Yangi soʻz qolmadi — takrorlash kunlarini kuting": "No new words left — wait for review days",
    "Reyting": "Leaderboard",
    "Guruh": "Group",
    "SIZNING OʻRNINGIZ": "YOUR RANK",
    "#-oʻringa chiqish uchun yana": "To reach #$1 you need",
    "Siz birinchi oʻrindasiz — oʻrningizni saqlang!": "You're #1 — keep it up!",
    "keyingi: #": "next: $1",
    "Yetakchi!": "Leader!",
    "* (siz)": "$1 (you)",
    "Siz": "You",
    "Test versiyada boshqa oʻquvchilar namunaviy. Toʻliq ilovada guruhingiz va oʻquv markazingiz oʻquvchilari chiqadi.": "Other learners are sample data in this test. The full app will show your group and learning center.",
    "Darajalar": "Levels",
    "Mavzular": "Topics",
    "Kartochkalarim": "My cards",
    "Soʻz qidirish": "Search words",
    "Lugʻatdan soʻz qidirish": "Search the dictionary",
    "Bazadan soʻz qidirish": "Search the word base",
    "Boshlangʻich": "Beginner",
    "Elementar": "Elementary",
    "Oʻrta": "Intermediate",
    "# soʻz · test toʻplami": "$1 words · test set",
    "Eng kerakli # soʻz": "Top $1 essential words",
    "Kundalik mavzular": "Everyday topics",
    "Ish, sayohat, oʻqish": "Work, travel, study",
    "# / # soʻz boshlangan": "$1 / $2 words started",
    "Mashhur mavzular": "Popular topics",
    "Hali kartochka yoʻq": "No cards yet",
    "“Yangi kartochka” tugmasini bosing va darsdagi soʻzlarni bazadan tanlab qoʻshing.": "Tap “New card” and add the words from class.",
    "Bitta kartochkaga # tagacha soʻz. Oʻquv markazidagi har dars uchun alohida kartochka oching. (Kartochka faollashtirilsa, darslar shu kartochkadan boradi.)": "Up to $1 words per card. Make a separate card for each class. (When a card is active, lessons use it.)",
    "Yangi kartochka": "New card",
    "Kartochka nomi": "Card name",
    "Masalan: #-dars": "E.g. Lesson $1",
    "Kartochkani tahrirlash": "Edit card",
    "Bazadan soʻz tanlang": "Pick words from the base",
    "Kartochka toʻldi": "Card is full",
    "/ # soʻz": "/ $1 words",
    "Saqlash va oʻrganish": "Save and learn",
    "Kamida # ta soʻz tanlang": "Pick at least $1 {word|words}",
    "Kartochka oʻchirildi": "Card deleted",
    "Joriy": "Current",
    "oʻrganilgan": "learned",
    "Hech narsa topilmadi.": "Nothing found.",
    "Bu soʻzlar allaqachon oʻrganilgan — takrorlashda chiqadi": "These words are already learned — they'll come up in review",
    "Darslar kartochkalaringizdan boradi": "Lessons use your cards",
    "Soʻzlar tasodifiy tartibda beriladi": "Words come in random order",
    "Tinglash": "Listen",
    "Tinglash: *": "Listen: $1",
    "Oila": "Family",
    "Ovqat": "Food",
    "Uy": "Home",
    "Vaqt": "Time",
    "Shahar": "City",
    "Feʼllar": "Verbs",
    "Sifatlar": "Adjectives",
    "Ranglar": "Colors",
    "Tana": "Body",
    "Taʼlim": "Education",
    "ot": "noun",
    "feʼl": "verb",
    "sifat": "adj.",
    "ravish": "adv.",
    "Kartochkalar": "Flashcards",
    "Aylantiring va eslang": "Flip and recall",
    "Oʻrganish": "Learn",
    "Tanlash, keyin yozish": "Choose, then write",
    "Juftlik": "Match",
    "# juftni tez toping": "Find $1 pairs fast",
    "# savol, baho": "$1 questions, score",
    "Eshit va yoz": "Listen & write",
    "Audio, sekin ijro": "Audio, slow mode",
    "Boʻsh joy": "Fill the gap",
    "Gapni toʻldiring": "Complete the sentence",
    "Tezkor #": "Speed $1",
    "Toʻgʻri yoki notoʻgʻri": "True or false",
    "Meteor": "Meteor",
    "Toʻgʻri soʻzni otib tushiring": "Shoot the right word",
    "Oʻrganilgan soʻzlar · #": "Learned words · $1",
    "Barcha soʻzlar · #": "All words · $1",
    "Oʻyinlar oʻrganilgan soʻzlaringizdan tuziladi (kamida # ta boʻlmasa — barcha # soʻzdan).": "Games use your learned words (if fewer than $1, all $2 words).",
    "Bu oʻyin Pro versiyada boʻladi": "This game is in Pro",
    "Bu qurilmada ovoz chiqmaydi": "No audio on this device",
    "Qaysi soʻzlar bilan oʻynaysiz?": "Which words do you want to play with?",
    "Tasodifiy": "Random",
    "Oʻzim tanlayman": "I'll choose",
    "Qayerdan": "Source",
    "Oʻrganilganlar · #": "Learned · $1",
    "Qiyin soʻzlar · #": "Difficult words · $1",
    "Nechta soʻz": "How many words",
    "Hali oʻrganilgan soʻz yoʻq": "No learned words yet",
    "Avval Bosh sahifada mashgʻulot oʻting — oʻrgangan soʻzlaringiz shu yerda chiqadi. Hozircha “Tasodifiy” rejimidan foydalaning.": "First do a lesson on Home — your learned words will appear here. For now use “Random”.",
    "Faqat oʻrganilgan soʻzlar (# ta) koʻrsatiladi.": "Only learned words ($1) are shown.",
    "# ta tanlandi": "$1 selected",
    "ta tanlandi": "selected",
    "Hammasini belgilash": "Select all",
    "Belgini olish": "Clear",
    "Tozalash": "Clear",
    "Oʻyinni boshlash": "Start game",
    "Avval soʻz oʻrganing": "Learn some words first",
    "Oʻynash uchun kamida # ta oʻrganilgan soʻz kerak. Avval Bosh sahifada mashgʻulot oʻting.": "You need at least $1 learned words to play. Do a lesson on Home first.",
    "Bu soʻzlar uchun misol gap yoʻq": "No example sentences for these words",
    "KARTOCHKA": "FLASHCARD",
    "Tarjimani koʻrsatish": "Show translation",
    "Juftini toping": "Find the pairs",
    "Hammasi topildi!": "All found!",
    "· yangi rekord!": "· new record!",
    "Juftlik toʻgʻrimi? Tez javob bering.": "Is the pair right? Answer fast.",
    "Toʻgʻri": "True",
    "Notoʻgʻri": "False",
    "Tarjimasini otib tushiring": "Shoot the translation",
    "TARJIMASINI OTIB TUSHIRING": "SHOOT THE TRANSLATION",
    "Toʻgʻri tarjimani bosing — toʻp uni otib tushiradi": "Tap the right translation — the cannon shoots it",
    "#-daraja": "Level $1",
    "Rekord #": "Best $1",
    "Rekord: #": "Best: $1",
    "Yangi rekord!": "New record!",
    "ball": "points",
    "Meteor: # ball": "Meteor: $1 points",
    "Tezkor #: # ball": "Speed $1: $2 points",
    "Yana oʻynash": "Play again",
    "Oʻyinlarga": "To games",
    "PRO": "PRO",
    "Tarjimani toping": "Find the translation",
    "Yozing": "Write",
    "Variantlar bilan tekshirish": "Check with options",
    "Talaffuz": "Pronunciation",
    "#/# · Oʻrganish": "$1/$2 · Learn",
    "#/# · Tarjimani toping": "$1/$2 · Find the translation",
    "#/# · Yozing": "$1/$2 · Write",
    "#/# · Variantlar bilan tekshirish": "$1/$2 · Check with options",
    "#/# · Talaffuz": "$1/$2 · Pronunciation",
    "#-bosqich: *": "Stage $1: @2",
    "Har bir soʻzni koʻring, tinglang va misolni oʻqing. Strelkalar bilan oldinga-orqaga yuring.": "See each word, listen and read the example. Use the arrows to move.",
    "Inglizcha soʻzning toʻgʻri oʻzbekcha tarjimasini tanlang.": "Choose the correct Uzbek translation of the English word.",
    "Ruscha soʻzning toʻgʻri oʻzbekcha tarjimasini tanlang.": "Choose the correct Uzbek translation of the Russian word.",
    "Oʻzbekcha soʻzni inglizcha yozing. Kataklar soni — harflar soni.": "Write the Uzbek word in English. One box per letter.",
    "Oʻzbekcha soʻzni ruscha yozing. Kataklar soni — harflar soni.": "Write the Uzbek word in Russian. One box per letter.",
    "Oʻzbekcha soʻzning inglizchasini variantlardan toping.": "Find the English for the Uzbek word.",
    "Oʻzbekcha soʻzning ruschasini variantlardan toping.": "Find the Russian for the Uzbek word.",
    "Namunani tinglang va soʻzni ovoz chiqarib ayting.": "Listen to the sample and say the word aloud.",
    "YANGI SOʻZ · #/#": "NEW WORD · $1/$2",
    "[soʻz rasmi]": "[word image]",
    "Qiyin?": "Hard?",
    "Qiyin": "Hard",
    "Qiyin soʻz deb belgilash": "Mark as difficult",
    "Qiyin soʻzlarga qoʻshildi": "Added to difficult words",
    "Qiyin soʻzlardan olindi": "Removed from difficult words",
    "Bilaman": "I know it",
    "Bilaman ✓": "I know it ✓",
    "Bilaman deb belgilandi": "Marked as known",
    "Oldingi soʻz": "Previous word",
    "Keyingi soʻz": "Next word",
    "Tekshirishni boshlash": "Start the check",
    "Misolni tinglash": "Listen to the example",
    "Toʻgʻri tarjimani tanlang": "Choose the correct translation",
    "Inglizchasini tanlang": "Choose the English word",
    "Ruschasini tanlang": "Choose the Russian word",
    "Eshiting va qaysi soʻz ekanini tanlang": "Listen and choose the word",
    "Tugmani bosib eshiting va qaysi soʻz ekanini tanlang": "Tap to listen and choose the word",
    "Inglizcha yozing": "Write in English",
    "Ruscha yozing": "Write in Russian",
    "Eshiting va inglizcha yozing": "Listen and write in English",
    "Eshiting va ruscha yozing": "Listen and write in Russian",
    "Yana bir bor: *": "One more time: @1",
    "Eshitish": "Play",
    "Sekin": "Slow",
    "# ta harf": "$1 {letter|letters}",
    "* · # ta harf": "@1 · $2 {letter|letters}",
    "Javobingiz": "Your answer",
    "Javob, # ta harf": "Answer, $1 {letter|letters}",
    "Katakka bosib yozishni boshlang": "Tap a box and start typing",
    "Imlo: *": "Spelling: $1",
    "Soʻzni ovoz chiqarib ayting": "Say the word aloud",
    "Namunani tinglash": "Listen to the sample",
    "Bosing va gapiring": "Tap and speak",
    "Gapirish": "Speak",
    "Hozir gapira olmayman": "I can't speak now",
    "Bu sahifada mikrofon ishlamaydi, shuning uchun talaffuz eshitib tanlash orqali tekshiriladi. Mobil ilovada ovozingiz tekshiriladi.": "The microphone doesn't work on this page, so pronunciation is checked by listening and choosing. The mobile app will check your voice.",
    "Qayta eshitish": "Listen again",
    "* — tugmani bosib, yana eshiting": "$1 — tap to listen again",
    "Eshitilmadi. Yana bosib, aniqroq ayting": "Didn't catch that. Tap again and speak clearly",
    "Eshitilmadi. Mikrofon ruxsatini tekshiring yoki “Hozir gapira olmayman”ni bosing": "Didn't catch that. Check microphone access or tap “I can't speak now”",
    "Yana urinib koʻring": "Try again",
    "Siz aytdingiz: *": "You said: $1",
    "Barakalla!": "Well done!",
    "Toʻgʻri javob:": "Correct answer:",
    "+# XP": "+$1 XP",
    "Bu soʻz shu bosqich oxirida yana chiqadi. Hamma soʻzlar toʻgʻri topilgach, keyingi bosqichga oʻtasiz.": "This word will come back at the end of the stage. Once all words are right, you move on.",
    "Bu soʻz oxirida yana chiqadi.": "This word will come back at the end.",
    "Toʻgʻrisi: * *. Bu soʻz shu bosqich oxirida yana chiqadi.": "Correct: $1 $2. This word will come back at the end of the stage.",
    "Hamma soʻzlarni bilasiz — dars yakunlandi": "You know all the words — lesson complete",
    "Dars tugadi!": "Lesson complete!",
    "Mashq tugadi!": "Practice complete!",
    "Kunlik maqsad bajarildi!": "Daily goal reached!",
    "Test: #/#": "Test: $1/$2",
    "Qiyin soʻzlar: #/#": "Difficult words: $1/$2",
    "Xatolar ustida ishlash: #/#": "Fix mistakes: $1/$2",
    "yangi + takror": "new + review",
    "savol": "questions",
    "aniqlik": "accuracy",
    "kun streak": "day streak",
    "# kunlik streak": "$1-day streak",
    "Bugun oʻrganildi": "Learned today",
    "Mashq qilingan soʻzlar": "Practiced words",
    "# ta xato · Qayta ishlash": "$1 {mistake|mistakes} · Redo",
    "Natijani nusxalash": "Copy result",
    "Natija nusxalandi": "Result copied",
    "Bosh sahifaga": "Back to Home",
    "MAX": "MAX",
    "Podkastlar": "Podcasts",
    "Kitoblar": "Books",
    "Kino-takror": "Shadowing",
    "#+ epizod": "$1+ episodes",
    "# ta kitob": "$1 books",
    "# sahna": "$1 scenes",
    "HAFTANING KITOBI": "BOOK OF THE WEEK",
    "Oʻqishni boshlash": "Start reading",
    "Davom ettiring": "Continue",
    "Kitob · #-bob": "Book · chapter $1",
    "Podkast · #:# / #:#": "Podcast · $1:$2 / $3:$4",
    "Kino-takror · #/# gap": "Shadowing · $1/$2 lines",
    "Tariflarni solishtirish": "Compare plans",
    "Bepul · Pro · Max": "Free · Pro · Max",
    "Test versiyada bu boʻlim namuna sifatida koʻrsatilgan — Max tarifda ochiladi.": "In this test the section is a preview — it unlocks with Max.",
    "Qidiruv Max tarifda ochiladi": "Search unlocks with Max",
    "Lexo Radio": "Lexo Radio",
    "Kitob javoni": "Bookshelf",
    "Darajali kitoblar": "Graded readers",
    "Shadowing": "Shadowing",
    "Darajangizga mos qisqa podkastlar. Subtitr bilan tinglang, tezlikni sekinlashtiring, notanish soʻzni bosib lugʻatingizga qoʻshing.": "Short podcasts for your level. Listen with subtitles, slow down, tap unknown words to add them.",
    "Mashhur asarlarning darajangizga moslashtirilgan versiyalari. Audio bilan birga oʻqing, har bob oxirida yangi soʻzlarni yodlang.": "Famous works adapted to your level. Read along with audio and learn new words after each chapter.",
    "Filmlardan qisqa sahnalarni koʻring va qahramon bilan bir vaqtda takrorlang. Talaffuz, urgʻu va ohangni tabiiy holda oʻrganasiz.": "Watch short movie scenes and repeat with the character. Learn pronunciation, stress and intonation naturally.",
    "Subtitr va oʻzbekcha tarjima": "Subtitles and Uzbek translation",
    "#.#× sekin ijro": "$1.$2× slow playback",
    "Soʻzni bosib kartochkaga qoʻshish": "Tap a word to add it to a card",
    "Har epizod oxirida # savollik test": "$1-question quiz after each episode",
    "A# dan B# gacha moslashtirilgan matn": "Adapted text from A$1 to B$2",
    "A# dan B# gacha moslashtirilgan matn (urgʻu belgilari bilan)": "Adapted text from A$1 to B$2 (with stress marks)",
    "Diktor ovozi bilan oʻqish": "Read along with a narrator",
    "Soʻzni bosib tarjima": "Tap a word to translate",
    "Bob oxirida soʻzlar mashqi": "Word practice after each chapter",
    "#–# soniyalik sahnalar": "$1–$2 second scenes",
    "Gapma-gap takrorlash": "Line-by-line repetition",
    "Ovozingizni yozib, asl bilan solishtirish": "Record yourself and compare with the original",
    "Talaffuz bahosi": "Pronunciation score",
    "Namuna roʻyxat": "Sample list",
    "Max tarifda ochiladi": "Unlocks with Max",
    "# daq": "$1 min",
    "# bet": "$1 pages",
    "# soniya": "$1 sec",
    "Salomlashish va tanishuv": "Greetings and introductions",
    "Doʻkonda xarid": "Shopping",
    "Sayohatdagi kun": "A day of travel",
    "Ob-havo va fasllar": "Weather and seasons",
    "Ish suhbatiga tayyorgarlik": "Preparing for a job interview",
    "Shahar hayoti haqida suhbat": "Talking about city life",
    "Kafedagi suhbat": "A talk at a café",
    "Kundalik suhbat · kafeda": "Everyday talk · at a café",
    "Ochiq litsenziyali animatsion film · #-sahna": "Open-licence animated film · scene $1",
    "Ilmiy-fantastik qisqa film · #-sahna": "Short sci-fi film · scene $1",
    "Klassik film · tanishuv sahnasi": "Classic film · meeting scene",
    "The Little Red Hen · xalq ertagi": "The Little Red Hen · folk tale",
    "Sherlock Holmes hikoyalari · A. Conan Doyle": "Sherlock Holmes stories · A. Conan Doyle",
    "Ochiq litsenziyali multfilm (rus tilida) · #-sahna": "Open-licence cartoon (in Russian) · scene $1",
    "Знакомство · tanishuv": "Знакомство · introductions",
    "В магазине · doʻkonda": "В магазине · at the shop",
    "Поездка в Самарканд · sayohat": "Поездка в Самарканд · a trip",
    "Разговор в кафе · kundalik suhbat": "Разговор в кафе · everyday talk",
    "На вокзале · chipta olish": "На вокзале · buying a ticket",
    "Репка · xalq ertagi": "Репка · folk tale",
    "Колобок · xalq ertagi": "Колобок · folk tale",
    "Филиппок · L. N. Tolstoy": "Филиппок · L. N. Tolstoy",
    "Каштанка · A. P. Chexov": "Каштанка · A. P. Chekhov",
    "Капитанская дочка · A. S. Pushkin": "Капитанская дочка · A. S. Pushkin",
    "A. P. Chexov · A# · # bet": "A. P. Chekhov · A$1 · $2 pages",
    "Oscar Wilde · A# · # bet": "Oscar Wilde · A$1 · $2 pages",
    "Tariflar": "Plans",
    "Tarifingiz": "Your plan",
    "Solishtirish ›": "Compare ›",
    "Bepul": "Free",
    "soʻm/oy": "UZS/mo",
    "# soʻm": "$1 UZS",
    "# soʻm / oy": "$1 UZS / month",
    "# soʻz": "$1 {word|words}",
    "# ta soʻz": "$1 {word|words}",
    "Cheklanmagan soʻzlar · barcha oʻyinlar · kartochkalar · statistika": "Unlimited words · all games · cards · stats",
    "Pro’dagi hammasi + podkastlar, kitoblar, kino-takror": "Everything in Pro + podcasts, books, shadowing",
    "Kuniga # ta yangi soʻz": "$1 new words a day",
    "Takrorlash cheksiz": "Unlimited reviews",
    "Asosiy mashqlar": "Core exercises",
    "Cheklanmagan soʻzlar": "Unlimited words",
    "Barcha oʻyinlar": "All games",
    "Kartochkalar va qiyin soʻzlar": "Cards and difficult words",
    "Batafsil statistika": "Detailed stats",
    "Pro’dagi hamma narsa": "Everything in Pro",
    "Lexo Radio — podkastlar": "Lexo Radio — podcasts",
    "Kitob javoni — darajali kitoblar": "Bookshelf — graded readers",
    "Kino-takror — shadowing": "Movie shadowing",
    "Talaffuz tahlili": "Pronunciation analysis",
    "Eng toʻliq": "Most complete",
    "Narxlar taxminiy. Test versiyada toʻlov yoʻq.": "Prices are approximate. No payments in the test version.",
    "Maxʼni sinab koʻrish": "Try Max",
    "Test versiyada toʻlov yoʻq — toʻliq ilovada ochiladi": "No payments in the test — coming in the full app",
    "Yodlangan": "Learned",
    "Kunlik streak": "Day streak",
    "Aniqlik": "Accuracy",
    "Shu hafta": "This week",
    "Yangi": "New",
    "Takrorlash": "Review",
    "* yangi, * takror": "$1 new, $2 reviews",
    "Sozlamalar": "Settings",
    "* · # soʻz/kun": "$1 · $2 words/day",
    "Soʻrovnoma javoblarim": "My survey answers",
    "Ingliz tili · A# · test versiya": "English · A$1 · test version",
    "Rus tili · A# · test versiya": "Russian · A$1 · test version",
    "Oʻrganish usuli": "Study mode",
    "Mustaqil": "On my own",
    "Kunlik maqsad": "Daily goal",
    "Test vositalari": "Test tools",
    "Ertangi kunga oʻtish": "Jump to tomorrow",
    "+# kun": "+$1 days",
    "Haqiqiy sanaga qaytish": "Back to real date",
    "Bir kun oldinga surildi": "Moved one day ahead",
    "Maʼlumotlarni boshqarish": "Data management",
    "Ingliz tili boʻyicha butun progress (soʻzlar, XP, streak, kartochkalar) oʻchiriladi. Buni qaytarib boʻlmaydi.": "All English progress (words, XP, streak, cards) will be deleted. This can't be undone.",
    "Rus tili boʻyicha butun progress (soʻzlar, XP, streak, kartochkalar) oʻchiriladi. Buni qaytarib boʻlmaydi.": "All Russian progress (words, XP, streak, cards) will be deleted. This can't be undone.",
    "Progressni tozalash": "Reset progress",
    "Progress faqat shu brauzerda saqlanadi. “Ertangi kunga oʻtish” takrorlash jadvalini kutmasdan sinash uchun.": "Progress is stored only in this browser. “Jump to tomorrow” lets you test reviews without waiting.",
    "Ingliz tili boʻyicha # ta soʻz, # XP va streak oʻchiriladi. Tasdiqlash uchun pastga": "$1 English {word|words}, $2 XP and your streak will be deleted. To confirm, type",
    "Rus tili boʻyicha # ta soʻz, # XP va streak oʻchiriladi. Tasdiqlash uchun pastga": "$1 Russian {word|words}, $2 XP and your streak will be deleted. To confirm, type",
    "deb yozing.": "below.",
    "Progress tozalandi": "Progress reset",
    "Ovoz topilmadi": "Voice not found",
    "Ingliz tili ovozi topilmadi": "English voice not found",
    "Rus tili ovozi topilmadi": "Russian voice not found",
    "Qurilmangizda rus tili ovozi oʻrnatilmagan, shuning uchun soʻzlar notoʻgʻri talaffuz qilinmasligi uchun ovoz oʻchirildi. Oʻrnating:": "No Russian voice is installed on your device, so audio is off to avoid wrong pronunciation. Install one:",
    "Qurilmangizda ingliz tili ovozi oʻrnatilmagan, shuning uchun soʻzlar notoʻgʻri talaffuz qilinmasligi uchun ovoz oʻchirildi. Oʻrnating:": "No English voice is installed on your device, so audio is off to avoid wrong pronunciation. Install one:",
    "Sozlamalar → Til va kiritish → Matnni nutqqa → Google → Русский ovozini yuklab oling": "Settings → Language & input → Text-to-speech → Google → download the Russian voice",
    "Sozlamalar → Til va kiritish → Matnni nutqqa → Google → English ovozini yuklab oling": "Settings → Language & input → Text-to-speech → Google → download the English voice",
    "Sozlamalar → Vaqt va til → Nutq → Ovoz qoʻshish → Русский": "Settings → Time & language → Speech → Add voices → Russian",
    "Sozlamalar → Vaqt va til → Nutq → Ovoz qoʻshish → English": "Settings → Time & language → Speech → Add voices → English",
    "• Yoki sahifani": "• Or open the page in",
    "da oching — unda rus ovozi tayyor boʻladi": "— it usually has a Russian voice built in",
    "da oching — unda ingliz ovozi tayyor boʻladi": "— it usually has an English voice built in",
    "Qoʻngʻiroqcha": "Bell",
    "Bitta tiniq zang": "One clear chime",
    "Ikki tez “ding”": "Two quick dings",
    "Uch notali arpedjio": "Three-note arpeggio",
    "Yumshoq, iliq ikki nota": "Two soft warm notes",
    "# ta takrorlash kutyapti": "$1 waiting for review",
    "# ta xato": "$1 {mistake|mistakes}",
    "#-raund": "Round $1",
    "#/# yodlangan": "$1/$2 learned",
    "1 ga 1 bellashuv": "1-on-1 match",
    "1 ga 1 · doʻst, raqib yoki bot": "1 vs 1 · friend, opponent or bot",
    "3–16 belgi: lotin harflari, raqam va _ . Reytingda va janglarda shu nom koʻrinadi.": "3–16 characters: Latin letters, digits and _. Shown in rankings and battles.",
    "7 kun": "7 days",
    "Aniqlik ~#% · javob ~# soniyada": "Accuracy ~$1% · answers in ~$2 s",
    "Avatar": "Avatar",
    "Avatar ramkasi": "Avatar frame",
    "Avatar saqlandi": "Avatar saved",
    "Avatar yasash": "Build avatar",
    "Avatarni olib tashlash": "Remove avatar",
    "Avatarni oʻzgartirish": "Change avatar",
    "Barcha oʻquvchilar": "All learners",
    "Binafsha": "Purple",
    "Birinchi darsni tugating": "Finish your first lesson",
    "Birinchi qadam": "First step",
    "Bot qiyinligini tanlang": "Choose bot difficulty",
    "Boʻsh kataklarni toʻldiring": "Fill in the empty boxes",
    "Bu safar raqib yutdi": "Your opponent won this time",
    "Bu shakl shu bosqich oxirida yana chiqadi.": "This form will come back at the end of the stage.",
    "Bugun takrorlash yoʻq": "Nothing to review today",
    "Bugungi darsni qilsangiz, streak davom etadi.": "Do today's lesson to keep the streak going.",
    "Doʻstingiz kutilmoqda…": "Waiting for your friend…",
    "Doʻstingizni taklif qiling": "Invite your friend",
    "Durang": "Draw",
    "Eshiting va raqamda yozing": "Listen and type the digits",
    "Feʼl juftlari": "Aspect pairs",
    "Feʼl ustasi": "Verb master",
    "Galereyadan tanlash": "Choose from gallery",
    "Gʻalaba!": "Victory!",
    "Harflarni barmoq bilan ilondek bogʻlab soʻz yasang": "Swipe through letters like a snake to make words",
    "Harflarni bogʻlab soʻz toping": "Link letters into words",
    "Havola nusxalandi": "Link copied",
    "Havola yuboring — doʻstingiz qoʻshiladi": "Send a link and your friend joins",
    "Hozir takrorlasangiz, ular uzoq xotiraga oʻtadi.": "Review now and they move to long-term memory.",
    "Ism": "Name",
    "Istisno: boshqa soʻz": "Exception: a different word",
    "Jang boshlanmoqda…": "Battle starting…",
    "Jangchi": "Fighter",
    "Javob — Enter": "Answer — Enter",
    "Jiddiy": "Serious",
    "Jingalak": "Curly",
    "Kepka": "Cap",
    "Keyingi son": "Next number",
    "Koʻz qisgan": "Wink",
    "Koʻzoynak": "Glasses",
    "Kulgan": "Smiling",
    "Kulgi": "Laugh",
    "Lexo afsonasi": "Lexo legend",
    "Lugʻat bilimdoni": "Vocab expert",
    "Masalan: Har kuni 10 ta soʻz!": "E.g. 10 words every day!",
    "Mashq oʻyinlari": "Practice games",
    "Mashq qilingan shakllar": "Practiced forms",
    "Mashqni boshlash": "Start practice",
    "Natija": "Result",
    "Natijalar": "Results",
    "Nickname": "Nickname",
    "Nickname 3–16 belgidan iborat boʻlsin: a–z, 0–9, _": "Nickname: 3–16 characters, a–z, 0–9, _",
    "Notoʻgʻri feʼllar": "Irregular verbs",
    "Nuqta": "Dots",
    "Old qoʻshimcha bilan": "With a prefix",
    "Olov": "On fire",
    "Oltin": "Gold",
    "Oson, oʻrta yoki qiyin raqib": "Easy, medium or hard opponent",
    "Profil saqlandi": "Profile saved",
    "Profilni tahrirlash": "Edit profile",
    "Qayta urinib koʻring": "Try again",
    "Qisqa": "Short",
    "Qiyinlikni tanlang": "Choose difficulty",
    "Qoʻshimcha oʻzgaradi": "Suffix changes",
    "Quloqchin": "Headphones",
    "Raqib qidirilmoqda…": "Finding an opponent…",
    "Rekord #/#": "Best $1/$2",
    "Roʻmol": "Headscarf",
    "Roʻyxat · #": "List · $1",
    "Saqlash": "Save",
    "Shaftoli": "Peach",
    "Shakl zanjiri": "Form chain",
    "Shior (ixtiyoriy)": "Motto (optional)",
    "Sonlar": "Numbers",
    "Sonlar: #/#": "Numbers: $1/$2",
    "Sonni raqamda yozing": "Type the number in digits",
    "Soʻz ilon": "Word snake",
    "Soʻz izlovchi": "Word seeker",
    "Soʻz jangi": "Word battle",
    "Soʻz jangida gʻalaba": "Win a word battle",
    "Soʻz ovchisi": "Word hunter",
    "Soʻz shakllari": "Word forms",
    "Soʻz shakllariga": "Back to word forms",
    "Soʻz ustasi": "Word master",
    "Surat yuklash": "Upload photo",
    "Tabassum": "Smile",
    "Taklif kodi": "Invite code",
    "Taymer son aytib boʻlingach boshlanadi. Sonni yana bir marta eshitish mumkin, lekin vaqt toʻxtamaydi.": "The timer starts once the number is spoken. You can replay it, but the clock keeps running.",
    "Tayyor": "Done",
    "Tez quloq": "Quick ears",
    "Til darajasi": "Language level",
    "Tinglang…": "Listen…",
    "Toj": "Crown",
    "Toʻgʻri:": "Correct:",
    "Tugallanmagan (jarayon) – tugallangan (natija)": "Imperfective (process) – perfective (result)",
    "Tugun": "Bun",
    "Uzun": "Long",
    "V1 – V2 (Past Simple) – V3 (Past Participle)": "V1 – V2 (Past Simple) – V3 (Past Participle)",
    "V2 — oʻtgan zamon (Past Simple), V3 — have/has + V3 (Present Perfect).": "V2 — past tense (Past Simple), V3 — have/has + V3 (Present Perfect).",
    "Vaqt tugadi": "Time's up",
    "XP boyvachchasi": "XP tycoon",
    "Xatosiz": "No mistakes",
    "YANGI SHAKL · #/#": "NEW FORM · $1/$2",
    "Yangi boshlovchi": "Beginner",
    "Yashil": "Green",
    "Yon tarash": "Side part",
    "Yordam": "Hint",
    "Yozing!": "Type!",
    "Yoʻq": "None",
    "Yutuqlar": "Achievements",
    "rekord": "best",
    "takrorlash": "review",
    "toʻgʻri": "correct",
    "yangi": "new",
    "yodlangan": "learned",
    "НСВ · jarayon": "Imperf. · process",
    "НСВ — jarayon, takrorlanish (“qilardim”); СВ — bir martalik natija (“qilib boʻldim”).": "Imperfective — a process or repetition; perfective — a one-time result.",
    "СВ · natija": "Perf. · result",
    "# juft": "$1 pairs",
    "# soʻz/kun": "$1 words/day",
    "# ta son, vaqt cheklangan.": "$1 numbers, time is limited.",
    "# xonali sonlar": "$1-digit numbers",
    "#–# xonali sonlar": "$1–$2-digit numbers",
    "#/# toʻgʻri": "$1/$2 correct",
    "#/# oʻrganildi": "$1/$2 learned",
    "7 raund · tez va toʻgʻri javob yutadi · gʻalaba +# XP": "7 rounds · fast and correct answers win · victory +$1 XP",
    "Avatar olib tashlandi": "Avatar removed",
    "Bu jang band": "This duel is already taken",
    "Bu nickname band — boshqasini tanlang": "This nickname is taken — choose another",
    "Doʻst va tasodifiy raqib bilan jang navbatma-navbat: har kim oʻz vaqtida oʻynaydi, natija ikkalasi oʻynagach chiqadi.": "Duels with a friend or a random opponent are turn-based: each plays at their own time, the result appears once both have played.",
    "Doʻstingiz hali qoʻshilmadi": "Your friend hasn't joined yet",
    "Eng kerakli soʻzlar": "The most essential words",
    "Havolani yuboring va hozir oʻynang — doʻstingiz keyin sizning natijangizga qarshi oʻynaydi.": "Send the link and play now — your friend will play against your result later.",
    "Havolani yuborish": "Send link",
    "Hozir onlayn raqib yoʻq": "No opponent online right now",
    "Hozir oʻynash": "Play now",
    "Jang topilmadi": "Duel not found",
    "Javob bering": "Your move",
    "Keyingi unvon": "Next title",
    "Natijani yuborib boʻlmadi": "Couldn't send the result",
    "Oʻynang — natijangizni keyingi raqib koʻradi, natija kelganda xabar beramiz.": "Play — the next opponent will face your result, we'll let you know when it's in.",
    "Oʻynash": "Play",
    "Qayta yuborish": "Resend",
    "Qiyin #/10": "Hard $1/10",
    "Raqib": "Opponent",
    "Raqib keyinroq oʻynaydi": "The opponent will play later",
    "Raqib natijasi kutilmoqda": "Waiting for the opponent's result",
    "Raqibingiz oʻynagach natija chiqadi — xabar beramiz.": "The result appears once your opponent plays — we'll let you know.",
    "Rasm kvadrat qilib qirqiladi va 256×256 px ga kichraytiriladi.": "The photo is cropped to a square and resized to 256×256 px.",
    "Rasmni ochib boʻlmadi": "Couldn't open the image",
    "Reyting barcha Lexo oʻquvchilari orasida. Haftalik reyting har dushanba yangilanadi.": "The ranking covers all Lexo learners. The weekly ranking resets every Monday.",
    "Saqlab boʻlmadi — internetni tekshiring": "Couldn't save — check your connection",
    "Siz yozdingiz:": "You wrote:",
    "Sizni jangga chaqirishdi": "You've been challenged",
    "Sonlar · Qiyin: 8/10": "Numbers · Hard: 8/10",
    "Soʻz jangida men bilan bellashing!": "Challenge me in a Word duel!",
    "Soʻz jangida raqiblar shu daraja boʻyicha tanlanadi. Hozircha soʻzlar A1 toʻplamidan.": "In Word duels opponents are matched by this level. For now words come from the A1 set.",
    "Tezkor 60": "Quick 60",
    "V2 · Past": "V2 · Past",
    "V3 · Participle": "V3 · Participle",
    "Yana bir bor: ": "Once more: ",
    "Yuklanmoqda…": "Loading…",
    "darajadagi onlayn oʻyinchilar orasidan": "among online players of level",
    "darajadagi oʻyinchilar": "players of level",
    "javob berdi": "answered",
    "keyinroq oʻynaydi": "will play later",
    "oʻylayapti…": "is thinking…",
    "oʻynagach natija chiqadi — xabar beramiz.": "plays — the result will appear, we'll let you know.",
    "qoʻshildi!": "joined!",
    "siz": "you",
    "Faqat": "Only",
    "Oldingi": "Previous",
    "ega boʻlmoq": "to have",
    "gapirib bermoq": "to tell",
    "hal qilmoq": "to solve",
    "izlamoq → topmoq": "to search → to find",
    "javob bermoq": "to answer",
    "ketmoq, qoldirmoq": "to leave",
    "olib kelmoq": "to bring",
    "olmoq (erishmoq)": "to get",
    "olmoq (qabul qilmoq)": "to receive",
    "olmoq (qoʻlga)": "to take",
    "qoʻngʻiroq qilmoq": "to call",
    "sotib olmoq": "to buy",
    "turmoq (oʻrnidan)": "to stand up",
    "yordam bermoq": "to help",
    "Oʻrtadan yuqori": "Upper intermediate",
    "Ilgʻor": "Advanced",
    "Mukammal": "Proficient",
    "Tanlash": "Choose",
    "Yana # ta soʻz — qidiruv bilan toraytiring": "$1 more words — narrow down with search",
    "Ingliz → oʻzbek": "English → Uzbek",
    "Rus → oʻzbek": "Russian → Uzbek",
    "Har kuni 10 daqiqa — soʻz boyligingiz oʻsib boradi.": "10 minutes a day — and your vocabulary grows.",
    "Darslar shu darajadagi soʻzlardan boshlanadi, soʻz jangida raqiblar ham shu daraja boʻyicha tanlanadi. Keyin Toʻplamlar boʻlimida almashtirish mumkin.": "Lessons start with words of this level, and Word duel opponents are matched by it too. You can change it later in Sets.",
    "Oʻyinlar oʻrganilgan soʻzlaringizdan tuziladi (kamida 6 ta boʻlmasa — barcha soʻzlardan).": "Games use the words you have learned (all words if fewer than 6).",
    "Kunlik maqsad (yangi soʻz)": "Daily goal (new words)",
    "Har dars shuncha yangi soʻz beradi, takrorlashlar bunga qoʻshimcha. Keyin Sozlamalarda 3 dan 10 gacha oʻzgartirish mumkin.": "Each lesson gives this many new words, reviews come on top. You can change it from 3 to 10 in Settings later.",
    "Fikr va takliflar": "Feedback",
    "Loyihani qoʻllab-quvvatlash": "Support the project",
    "Lexo bepul va reklamasiz. Loyiha rivoji uchun istalgan summa bilan qoʻllab-quvvatlashingiz mumkin:": "Lexo is free and ad-free. You can support the project with any amount:",
    "Karta raqamini nusxalash": "Copy card number",
    "Karta raqami nusxalandi": "Card number copied",
    "Rahmat! 💜 Karta raqami Profil boʻlimida ham turadi.": "Thank you! 💜 The card number is also in your Profile.",
    "Keyinroq": "Later",
    "Muammo": "Problem",
    "Taklif": "Idea",
    "Biz har bir fikrni oʻqiymiz. Nima haqida yozmoqchisiz?": "We read every message. What would you like to tell us?",
    "Fikringiz, taklifingiz yoki duch kelgan muammo…": "Your feedback, idea or a problem you hit…",
    "Yuborish": "Send",
    "Kamida 3 ta belgi yozing": "Write at least 3 characters",
    "Rahmat! Fikringiz yuborildi": "Thanks! Your feedback was sent",
    "Bugun yetarli — rahmat! Ertaga davom etamiz": "That is enough for today — thank you! See you tomorrow",
    "Yuborib boʻlmadi — internetni tekshiring": "Could not send — check your connection",
    "# ta boshlangan": "$1 started",
    "Barcha soʻzlardan": "From all words",
    "Bugungi reja bajarildi — ertaga davom etamiz": "Today's plan is done — see you tomorrow",
    "Ertaga yana # ta yangi soʻz": "$1 more {new word|new words} tomorrow",
    "Bu soʻz keyingi darslarda qayta oʻrganiladi": "We'll relearn this word in the next lessons"
  }
}
